<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/accident/periodical"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
        <template #handle="{ row }">
          <el-button type="text" @click="handleRow(row, 'log')">分摊记录</el-button>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Log",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
    };
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {},
  methods: {
    handleRow(row, k) {
      switch (k) {
        case "log":
          this.handleRowLog(row);
          break;
        default:
          break;
        }
    },
    handleRowLog({ id }) {
      this.$router.push({
        path: "/journal/log",
        query: {
          id,
        },
      });
    },
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>
